<template>
  <section class="shared-section">
    <header class="shared-section-header">
      <h2 class="pl-4 shared-section-header-heading sm:pl-0">Referral History</h2>
    </header>

    <ReferralsTable
      :tColumns="$options.tColumns"
      :tData="referrers"
      :tNestedColumns="$options.tNestedColumns"
      :tNestedData="referralsAll"
      :getTData="getReferrers"
      :getReferrals="getReferralsByReferrer"
      :styles="{ ...$options.styles }"
      :withTooltip="true"
    >
      <template #table-toolbar>
        <button class="shared-table-toolbar-button">
          <download-csv
            :data="csvData"
            :fields="$options.csvProps.fields"
            :labels="$options.csvProps.labels"
          >
            <div class="flex items-center">
              <VSvgIcon name="export" class="h-5 mr-1" /> export .csv
            </div>
          </download-csv>
        </button>
      </template>
    </ReferralsTable>
  </section>
</template>

<script>
import { mapState } from 'vuex';

import { safeNullDataset, normalizeAdminReferrers, normalizeAdminReferralsCsv } from '@/utils';

import VSvgIcon from '@/components/base/VSvgIcon';
import ReferralsTable from '@/components/admin/ReferralsTable';

export default {
  name: 'AdminReferralsHistory',
  components: {
    VSvgIcon,
    ReferralsTable,
  },
  data() {
    return {
      csvData: [],
    };
  },
  computed: mapState({
    referrers: state => ({
      data: normalizeAdminReferrers(safeNullDataset(state)(['admin', 'referrers', 'data'])),
      meta: state.admin.referrers.meta,
    }),
    referralsAll: state => state.admin.referralsAll,
  }),
  methods: {
    getReferralsByReferrer(id) {
      return async (params = {}) =>
        await this.$store.dispatch('admin/getReferralsAll', { id, params });
    },
    async getReferrers(params) {
      return await this.$store.dispatch('admin/getReferrers', params);
    },
    async fetchCsvExport() {
      const { data } = await this.$http.get('/admin/referrers/csv');
      this.csvData = normalizeAdminReferralsCsv(safeNullDataset(data)(['data']));
    },
  },
  csvProps: {},
  styles: {},
  tNestedColumns: [],
  tColumns: [],
  async created() {
    /*
     * Parent Table Columns
     */
    const TABLE_COLUMNS = [
      { column: "referrer's name", isSort: false },
      { column: "referrer's tag type", isSort: false },
      { column: 'sales rep', isSort: false },
      { column: 'phone number', isSort: false },
      { column: 'email', isSort: false },
    ];
    this.$options.tColumns = TABLE_COLUMNS;

    /*
     * Nested Table Columns
     */
    const TABLE_NESTED_COLUMNS = [
      { column: 'person referrerd', isSort: false },
      { column: 'order details', isSort: false },
      { column: 'date created', isSort: false },
      { column: 'shopify reward', isSort: false },
      { column: 'sales order', isSort: false },
      { column: 'invoice/memo #', isSort: false },
      { column: 'order total', isSort: false },
      { column: 'percentage earned', isSort: false },
      { column: 'referral value', isSort: false },
      { column: 'total balance', isSort: false },
    ];
    this.$options.tNestedColumns = TABLE_NESTED_COLUMNS;

    /*
     * Row grid styles
     */
    this.$options.styles = {
      display: 'grid',
      gridTemplateColumns:
        '50px repeat(2,minmax(200px, 1fr)) minmax(200px, 1fr) 130px minmax(250px, 1fr)',
    };

    /*
     * Downloadable CSV
     */
    const CSV_FIELDS = [
      'referrer',
      'customer',
      'date',
      'shopify_reward',
      'sales_order',
      'invoice_memo_number',
      'order_total',
      'percentage_earned',
      'referral_value',
      'type',
      'balance',
    ];
    const CSV_LABELS = {
      referrer: 'REFERRER',
      customer: 'CUSTOMER',
      date: 'DATE',
      shopify_reward: 'SHOPIFY REWARD',
      sales_order: 'SALES ORDER',
      invoice_memo_number: 'INVOICE/MEMO #',
      order_total: 'ORDER_TOTAL',
      percentage_earned: 'PERCENTAGE EARNED',
      referral_value: 'REFERRAL_VALUE',
      type: 'TYPE',
      balance: 'BALANCE',
    };
    const fields = CSV_FIELDS;
    const labels = CSV_LABELS;
    this.$options.csvProps = { fields, labels };
    this.fetchCsvExport();
  },
};
</script>
